import React, { ReactElement } from 'react'
import HeroIcon from 'images/organization/industries/schools/hero.png'
import AIPoweredFilteringIcon from 'images/organization/industries/schools/ai-powered.svg'
import CIPAComplianceIcon from 'images/organization/industries/schools/cipa.svg'
import CustomizableByAgeAndGradeIcon from 'images/organization/industries/schools/customizable-by-age.svg'
import NoHardwareRequiredIcon from 'images/organization/industries/schools/no-hardware-required.svg'
import LandingPageLayout from 'components/Organization/LandingPageCommonComponents/LandingPageLayout'
import HeroSection from 'components/Organization/LandingPageCommonComponents/HeroSection'
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'
import SectionDivider from 'components/Organization/LandingPageCommonComponents/SectionDivider'
import { frequentlyAskedQuestions } from './Sections/frequentlyAskedQuestions'
import WhySchoolNeedContentFiltering from './Sections/WhySchoolNeedContentFiltering'
import ContentFilteringFeatures from './Sections/ContentFilteringFeatures'
import InternetSafety from './Sections/InternetSafety'
import Features from './Sections/Features'
import CTAButtons from '../Common/CTAButtons'
import EasyToSetup from './Sections/EasyToSetup'
import ScalablePricingPlans from './Sections/ScalablePricingPlans'
import TrustedByExperts from 'components/Organization/Features/TrustedByExperts/TrustedByExperts'
import { Flex } from 'theme-ui'
import CompactFeatures, {
  FeaturesDivider,
  FeaturesItem,
} from 'components/Organization/Industries/Common/CompactFeatures'

export default function Schools(): ReactElement {
  return (
    <LandingPageLayout>
      <HeroSection
        title="Web Content Filtering for Schools – Keep Students Safe & Focused"
        titleVariant={['size32Weight500', 'size40Weight600']}
        description="AI-powered, customizable content filtering for schools: block inappropriate websites, enforce safe browsing policies, and maintain CIPA compliance—all with a simple, cloud-based solution."
        image={HeroIcon}
      />

      <CompactFeatures>
        <FeaturesItem
          icon={AIPoweredFilteringIcon}
          title="AI-Powered Filtering"
          description="Blocks harmful & distracting content in real-time."
        />
        <FeaturesDivider />
        <FeaturesItem
          icon={CIPAComplianceIcon}
          title="CIPA Compliance"
          description="Meets legal requirements for student internet safety."
        />
        <FeaturesDivider />
        <FeaturesItem
          icon={CustomizableByAgeAndGradeIcon}
          title="Customizable by Age & Grade"
          description="Set different policies for K-12, middle, and high school."
        />
        <FeaturesDivider />
        <FeaturesItem
          icon={NoHardwareRequiredIcon}
          title="No Hardware Required"
          description="Deploy school-wide DNS filtering in minutes."
        />
      </CompactFeatures>

      <WhySchoolNeedContentFiltering />
      <ContentFilteringFeatures />
      <Features />
      <CTAButtons />
      <InternetSafety />
      <EasyToSetup />

      {/* TODO: it should be replaced with TrustedBySchoolsWorldwide component with the real reviews*/}
      <Flex sx={{ mt: ['4rem', '8rem'] }}>
        <TrustedByExperts />
      </Flex>
      <SectionDivider
        sx={{
          my: ['8rem', '12rem'],
        }}
      />

      <FrequentlyAskedQuestions data={frequentlyAskedQuestions} />
      <SectionDivider
        sx={{
          my: ['8rem', '12rem'],
        }}
      />

      <ScalablePricingPlans />
    </LandingPageLayout>
  )
}
